import {ActivityCarBusState} from "../../types-enums/activity-car-bus";
import {isCarBusCalculationRequest} from "../check/type-guards";

/**
 * Adjusts the duration for car-bus activities when adding to a journey.
 *
 * This function sets the `countDays` property of the provided `carBus` object
 * to 1. Additionally, if a valid car-bus calculation request exists within the
 * `carBus.common.request` array, the `daysOfUse` property of the first element
 * in the request is also updated to 1.
 *
 * @param {ActivityCarBusState} carBus - The state object representing car-bus-specific activity details.
 */
export const setCarBusDurationToOneWhenAddingToJourney = (carBus: ActivityCarBusState) => {
    carBus.countDays = 1
    if (carBus.common.request && isCarBusCalculationRequest(carBus.common.request[0])) carBus.common.request[0].daysOfUse = 1
}